import ImageWithFallback from '../image';
import pageLoader from '../../../public/eflLoader.gif';
import Loader from '../loader';

interface PageLevelLoaderProps {
  classNames?: string;
  loaderType?: 'default' | 'eflLoader';
}

export const PageLevelLoader = (props: PageLevelLoaderProps) => {
  const { classNames, loaderType = 'default' } = props;
  return (
    <div
      className={`fixed grid place-content-center w-full h-full inset-0 bg-[#00000080] z-50 ${classNames}`}
      data-testid="pageLevelLoader"
    >
      <div data-testid="pageLoaderImage">
        {loaderType === 'eflLoader' ? (
          <ImageWithFallback src={pageLoader} alt={'Page Loader'} />
        ) : (
          <Loader />
        )}
      </div>
    </div>
  );
};
